import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useFlashSale = () => {
  const [flashSaleData, setFlashSaleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorFooter, setError] = useState(null);

  useEffect(() => {
    const fetchFlashSale = async () => {
      try {
        // const response = await fetch(`https://sasuperstore.com/api/flashSale`);
        const response = await fetch(apiUrl("flashSale"));
        if (!response.ok) {
          throw new Error("Failed to fetch flash sale data");
        }
        const data = await response.json();
        setFlashSaleData(
          data && data.remaining_seconds !== undefined ? data : null,
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFlashSale();
  }, []);

  return { flashSaleData, loading, errorFooter };
};

export default useFlashSale;
